"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList className="gap-0">
          {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-foreground transition-all duration-150 hover:!bg-transparent focus:!bg-transparent relative after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:bg-primary after:-translate-x-1/2 after:transition-all after:duration-300 hover:after:w-full hover:font-semibold focus:after:w-full focus:font-semibold outline-none">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b border-border shadow-medium md:hidden z-50">
          <nav className="container py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map(item => <li key={item.id} data-index={item.id}>
                  <Link to={item.href || "#"} className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-accent/50 rounded-md transition-all duration-150" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`fixed top-0 left-0 right-0 z-50 bg-background transition-all duration-300 ${scrolled ? "h-16 border-b border-border shadow-soft" : "h-[90px]"}`}>
      <div className="container h-full flex items-center justify-between">
        {}
        <Link to="/" className="flex-shrink-0">
          <img src="https://unitylanguageacademy.10web.cloud/wp-content/uploads/2026/02/logo-Recovered.png" alt="Unity Language Academy" className="h-7" />
        </Link>

        {}
        <div className="flex items-center gap-6">
          <MenuProvider menu_id="20" className="flex items-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          <Button asChild className="bg-accent text-foreground-accent hover:bg-accent-hover hover:!bg-accent-hover active:bg-accent-active border-2 border-accent hover:border-accent-hover hover:-translate-y-0.5 active:translate-y-0 transition-all duration-150 focus:!bg-accent-hover outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            <Link to="/AdmissionsAndContactPage">Enroll Now</Link>
          </Button>
        </div>
      </div>
    </header>;
}